export default [
  {
    name: "Breadcrumbs",
    data: {
      pt: [
        { text: "UA", url: "/" },
        { text: "investigar", url: "/investigacao" },
        { text: "atividade científica", url: "/atividade-cientifica" },
        { text: "projetos i&d", url: "/projetos-id" }
      ],
      en: [
        { text: "UA", url: "/" },
        { text: "research", url: "/uaresearch" },
        { text: "scientific activity", url: "/scientific-activity" },
        { text: "r&d projetos", url: "/id-projects" }
      ]
    }
  },
  {
    name: "ProjectsList",
    data: {
      pt: {
        title: "Projetos I&D",
        content:
          "\nProdutos e soluções inovadoras são desenvolvidos na Universidade de Aveiro para contribuir para o avanço da ciência e tecnologia.  A Universidade é um parceiro privilegiado de empresas e outras organizações nacionais e internacionais com as quais coopera em numerosos projetos e para os quais presta serviços importantes.\n\nDurante 2019, 628 projetos de investigação e inovação estavam ativos na Universidade de Aveiro, 134 destes com colaboração internacional.  40 projetos são financiados pelo Programa ERASMUS+ e 48 pelo Horizonte 2020. Entre esses projetos H2020, estão 3 bolsas ERC ativas e outras 3 foram aprovadas para financiamento.\n\nConsulte os projetos de investigação financiados por fundos europeus com a coordenação ou participação de investigadores da Universidade de Aveiro.\n\n Esta lista encontra-se em atualização."
      },
      en: {
        title: "R&D projects",
        content:
          "\nInnovative products and solutions are developed at the University of Aveiro to contribute to the advancement of science and technology. The University is a privileged partner of companies and other national and international organizations with whom it cooperates in numerous projects and for which it provides important services.\n\nDuring 2019, 628 research and technology transfer projects have been active in UAVR, 134 of these with international collaboration.  40 projects were funded by ERASMUS+ and 48 by Horizon 2020. Among these projects are 3 ongoing ERC Grants and three more were approved for funding. \n\n See  projects unded by European funds with the coordination or participation of researchers from the University of Aveiro.\n\n The project list is still being updated.\n\n"
      }
    }
  }
];
